import React, { Component } from 'react';
import AppHeader            from './../components/App/AppHeader';
import AppFavIcon           from '../components/App/AppFavIcon';
import MuiThemeProvider     from 'material-ui/styles/MuiThemeProvider';
import Message              from './../containers/MessageContainer';
import LoadingSvg           from '../components/LoadingSvg';

class App extends Component
{
    constructor(props)
    {
        super(props);

        if (this.props.auth.fetched)
        {
            this.props.fetchData();
        }
    }

    componentWillReceiveProps = (nextProps) =>
    {
        if (null === this.props.filter && null !== nextProps.filter)
        {
            this.props.initGeo();
        }
    };

    renderApp = () => {
        return (
            <div>
                <AppHeader theme={ this.props.theme } registerGoogle={ this.props.registerGoogle } />
                <AppFavIcon logo={ this.props.logo } />

                <MuiThemeProvider>
                    {this.props.children}
                </MuiThemeProvider>

                <MuiThemeProvider>
                    <Message />
                </MuiThemeProvider>
            </div>
        );
    };

    render = () => {
        let body;
        if (null === this.props.theme)
        {
            body = (
                <MuiThemeProvider>
                    <div style={ { height: '100vh' } }>
                        <LoadingSvg />
                    </div>
                </MuiThemeProvider>
            )
        }
        else
        {
            body = this.renderApp();
        }

        return (
            <div>
                { body }
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/pages/App.js